export default __webpack_public_path__ + "static/men5-5a0d644a4397c6c44228007ac3f19f73.webp";